var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-sm-12 col-md-5 col-lg-5"},[_c('BQdtCard',{attrs:{"name":"complaintsHomeLFLType","type":"header-item"}})],1),_c('div',{staticClass:"col-sm-12 col-md-5 col-lg-5"},[_c('BQdtCard',{attrs:{"name":"complaintsHomeMain","type":"header-item"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }